/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CALLOUT INDICATOR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	callout: {
		background: theme.color.light.light.swatch,
		borderRadius: pxToEm(6),
		border: replacePXinStringWithEM(`1px solid #ECF0F7`),
		boxShadow: replacePXinStringWithEM(`0 1px 1px 0 #EDF1FA`),
		position: 'relative',
		transition: 'all .2s linear 0s',
        '&.rail': {
        	width: '32%',
            minWidth: pxToEm(224), //pxToEm(324),
            maxWidth: pxToEm(384),
            margin: replacePXinStringWithEM('0px .65% 20px'),
            '& .bodyarea': {
                height: pxToEm(397),
                paddingTop: pxToEm(15),
            },
        },
        '&.incontent': {
        	width: '32%',
            minWidth: pxToEm(271), // pxToEm(371),
            maxWidth: pxToEm(400),
            margin: replacePXinStringWithEM('0px .65% 20px'),
            '& .bodyarea': {
                height: pxToEm(347),
                paddingTop: pxToEm(15),
                '& > img': {
                	width: '85%',
                	height: 'auto'
                }
            },
        },
		'& .headline': {
			width: '100%',
			padding: replacePXinStringWithEM('10px 15px 0'),
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			transition: 'background .2s linear 0s',
			'& .title': {
				color: theme.color.primary.medium.swatch,
				extend: theme.typography.size.small
			},
			'& .toggle': {
				fontSize: '50%'
			},
			'& .group': {
				'&:first-child': { textAlign: 'left' },
				'&:last-child': { textAlign: 'right' }
			}
		},
		'& .bodyarea': {
			width: '100%',
			textAlign: 'center',
			position: 'relative',
			extend: theme.typography.size.small,
			transition: 'opacity .2s linear 0s',
		},
		'&.on': {
			borderColor: theme.color.primary.light.swatch,
		},
		'&.off': {
			'& .bodyarea': { opacity: '.3', pointerEvents: 'none' }
		},
		'&:hover': {
			boxShadow: replacePXinStringWithEM(`0 0 15px 0 rgba(0,0,0,0.15)`)
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thinnest]: { 
        callout: {
            '&.rail, &.incontent': {
                width: '80%'
            }
        }
    }
});


